import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider, db } from './firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        const user = result.user;
        return user;
    } catch (error) {
        console.error("Error signing in with Google", error);
        throw error;
    }
};

export const getUserHighScore = async (uid) => {
    if (!uid) return 0;

    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) return 0;

    const data = snap.data();
    return typeof data.topScore === "number" ? data.topScore : 0;
};

export const setUserHighScore = async (uid, topScore) => {
    if (!uid) return;

    const ref = doc(db, "users", uid);
    await setDoc(
        ref,
        {
            topScore,
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
};

export const getUserCollection = async (uid) => {
    if (!uid) return [];

    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) return [];

    const data = snap.data();
    const arr = Array.isArray(data.collectionUnlocked) ? data.collectionUnlocked : [];
    // Normalize to numbers when possible
    return arr
        .map((x) => {
            const n = Number(x);
            return Number.isFinite(n) ? n : x;
        })
        .filter((x) => x !== null && x !== undefined);
};

export const setUserCollection = async (uid, collectionUnlocked) => {
    if (!uid) return;

    const ref = doc(db, "users", uid);
    await setDoc(
        ref,
        {
            collectionUnlocked: Array.isArray(collectionUnlocked)
                ? collectionUnlocked
                : [],
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
};

export const getUserFoilCollection = async (uid) => {
    if (!uid) return [];

    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) return [];

    const data = snap.data();
    const arr = Array.isArray(data.collectionFoilUnlocked)
        ? data.collectionFoilUnlocked
        : [];

    return arr
        .map((x) => {
            const n = Number(x);
            return Number.isFinite(n) ? n : x;
        })
        .filter((x) => x !== null && x !== undefined);
};

export const setUserFoilCollection = async (uid, collectionFoilUnlocked) => {
    if (!uid) return;

    const ref = doc(db, "users", uid);
    await setDoc(
        ref,
        {
            collectionFoilUnlocked: Array.isArray(collectionFoilUnlocked)
                ? collectionFoilUnlocked
                : [],
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
};

export const getUserProfile = async (uid) => {
    if (!uid) {
        return null;
    }

    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
        return null;
    }

    const data = snap.data();

    return {
        username: typeof data.username === "string" ? data.username : "",
        profileImageId:
            data.profileImageId !== null && data.profileImageId !== undefined
                ? data.profileImageId
                : null,
        gamesPlayed:
            typeof data.gamesPlayed === "number" ? data.gamesPlayed : 0,
    };
};

export const setUserProfile = async (uid, profileData) => {
    if (!uid) {
        return;
    }

    const ref = doc(db, "users", uid);

    await setDoc(
        ref,
        {
            ...profileData,
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
};

// path: src/firebaseUtils.js

export const getUserHearts = async (uid) => {
    if (!uid) {
        return null;
    }

    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
        return null;
    }

    const data = snap.data();

    const hearts = Number(data.hearts);
    const heartLastRefillAt = Number(data.heartLastRefillAt);

    if (!Number.isFinite(hearts) || !Number.isFinite(heartLastRefillAt)) {
        return null;
    }

    return {
        hearts,
        heartLastRefillAt,
    };
};

export const setUserHearts = async (uid, heartData) => {
    if (!uid) {
        return;
    }

    const ref = doc(db, "users", uid);

    await setDoc(
        ref,
        {
            hearts: Number(heartData?.hearts),
            heartLastRefillAt: Number(heartData?.heartLastRefillAt),
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
};